<template>
    <Cadastrado
        v-if="form.identificacao"
        :form="form.identificacao"
    />

    <Desconhecido
        v-else
        :form="form.desconhecido"
        :model="model"
    />
</template>

<script>
import Cadastrado from './cadastrado/Index'
import Desconhecido from './desconhecido/Index'

export default {
    components: { Cadastrado, Desconhecido },
    props: {
        form: { type: Object, required: true },
        model: { type: Object, required: true },
    }
}
</script>